// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3kWiL","range":"MonthRangeSwitch_range__1C0pr","disabled":"MonthRangeSwitch_disabled__w-RKE"};